export default {
  "content": "<title>plus</title><path d=\"M12.997 3.098h-1.994v7.905H3.097v1.994h7.906v7.905h1.994v-7.905h7.905v-1.994h-7.905V3.098z\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};